import axios from "@/network";
import { QueryParams } from "../types";

export function apiGetAudit(params: QueryParams) {
  const url = "/audits";

  return axios.get(url, { params });
}
